import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=ecf32ccc&scoped=true&"
import script from "./DetailDrawer.vue?vue&type=script&lang=js&"
export * from "./DetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=ecf32ccc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf32ccc",
  null
  
)

export default component.exports